import { EngagementState } from "backend/model/engagementState";

export const RemoteStorageStates = [
  EngagementState.RemoteStorage,
  EngagementState.Restoring,
  EngagementState.RestoreFailed,
  EngagementState.EngagementDeletionFailed,
  EngagementState.DeletionPending,
  EngagementState.InTransit,
  EngagementState.InTransitFailed,
] as const satisfies string[];
